(function ($, Drupal) {
  Drupal.behaviors.scrollToViewResults = {
    attach: function (context, settings) {
      $(document).ajaxSuccess(function (event, xhr, settings) {
        if (settings.url.includes('/views/ajax')) {
            const $target = $('.view-tires.view-display-id-tires_page .view-main-content');
            if ($target.length) {
              $('html, body').animate({
                scrollTop: $target.offset().top - 100
              }, 1);
            }
        }
      });
    }
  };
})(jQuery, Drupal);
